<div class="dropdown">
  <button class="dropdown__toggle" (click)="toggleDropdownMenu()">
    @if (titleIcon()) {
    <i [class]="titleIcon()"></i>
    }
    {{ title() }}
    <i class="ph ph-bold" [class.ph-caret-up]="isOpen" [class.ph-caret-down]="!isOpen"></i>
  </button>
  @if(isOpen) {
  <ul class="dropdown__menu">
    @for (option of options(); track option; let index = $index) {
    <li class="dropdown__menu-item" [class.highlighted]="highlightedIndex === index" [class.no-icon]="!option.icon">
      @if (option.url) {
      <a [attr.href]="option.url" (click)="closeMenu()">
        @if (option.icon) {
        <i [className]="option.icon"></i>
        }
        {{ option.translateLabel === false ? option.label : (option.label | translate) }}
      </a>
      }
      @if (option.action) {
      <button (click)="onAction(option.action)">
        @if (option.icon) {
        <i [className]="option.icon"></i>
        }
        {{ option.translateLabel === false ? option.label : (option.label | translate) }}
      </button>
      }
    </li>
    }
  </ul>
  }
</div>
